import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import { io } from "socket.io-client";
import BackButton from "../../Components/BackButton";
import CustomButton from "../../Components/CustomButton";
import CustomInput from "../../Components/CustomInput";
import ImageViewer from "../../Components/ImageViewer";
import { DashboardLayout } from "../../Components/Layout/DashboardLayout";
import Loader from "../../Components/Loader";
import ProfileDisplay from "../../Components/ProfileDisplay";
import { useGetBookingQuery, useGetMessagesQuery } from "../../Redux/Apis/Booking";
import { dateFormatter } from "../../Utils";
import "./style.css";

const Messages = () => {

    const { id } = useParams();
    const { user } = useSelector(state => state.authSlice)

    const { data, isLoading, isSuccess } = useGetMessagesQuery({ id });
    const { data: booking_data } = useGetBookingQuery({ id });

    const [socket, setSocket] = useState(null);
    const [messages, setMessages] = useState([]);
    const [message, setMessage] = useState("");

    useEffect(() => {
        if (isSuccess) {
            let copy_messages = [...data?.data?.messages];
            setMessages([{ ...data?.data?.booking?.message, sender: data?.data?.booking?.message?.user }, ...copy_messages?.reverse()])
        }
    }, [isSuccess, data])

    useEffect(() => {

        const newSocket = io(process.env.REACT_APP_IMAGE_ENDPOINT, {
            query: { user_id: user?._id },
        });

        setSocket(newSocket);

        newSocket.emit("join", { booking: id });
        newSocket.on("message", (data) => {
            console.log("message from socket", data)
            setMessages((prevMessages) => [...prevMessages, data]);
        });

        return () => {
            newSocket.disconnect();
        };

    }, [user, id]);

    useEffect(() => {
        if (socket) {
            socket.emit("join", { booking: id });
        }
    }, [socket, id])

    const sendMessage = () => {
        if (socket && message.trim()) {
            socket.emit("message", {
                booking: id,
                message,
            });
            setMessage("");
        }
    };

    return (
        <DashboardLayout>
            <div className="dashCard mb-4">
                <div className="row mb-3">
                    <div className="col-12 mb-2">
                        <h2 className="mainTitle">
                            <BackButton />
                            Messages
                        </h2>
                    </div>
                </div>
                <div className="row mb-3">
                    {
                        isLoading ? <Loader /> :
                            <>
                                <div className="bg-white p-3 mx-3" style={{ borderRadius: "12px" }}>
                                    <h4>{data?.data?.booking?.service_name}</h4>
                                    <p>{data?.data?.booking?.description}</p>
                                    <div className="row mb-3">
                                        <div className="col-md-3">
                                            <label className="secondaryText">Sitter Profile</label>
                                            <ProfileDisplay
                                                email={data?.data?.booking?.to_user.email}
                                                image={data?.data?.booking?.to_user.profile_photo}
                                                name={`${data?.data?.booking?.to_user.first_name} ${data?.data?.booking?.to_user.last_name}`}
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <label className="secondaryText">User Profile</label>
                                            <ProfileDisplay
                                                email={data?.data?.booking?.from_user.email}
                                                image={data?.data?.booking?.from_user.profile_photo}
                                                name={`${data?.data?.booking?.from_user.first_name} ${data?.data?.booking?.from_user.last_name}`}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {
                                    booking_data?.data?.start_image || booking_data?.data?.end_image ? (
                                        <div className="bg-white p-3 mx-3 mt-3" style={{ borderRadius: "12px" }}>
                                            <h4>Booking Proofs</h4>
                                            <div className="d-flex">
                                                {
                                                    booking_data?.data?.start_image ? (
                                                        <div>
                                                            <p className="mb-1">Booking Start Image</p>
                                                            <ImageViewer src={`${process.env.REACT_APP_IMAGE_ENDPOINT}${booking_data?.data?.start_image}`} image_style={{ height: "200px", width: "200px" }} image_classname="me-2" />
                                                        </div>
                                                    ) : null
                                                }
                                                {
                                                    booking_data?.data?.end_image ? (
                                                        <div>
                                                            <p className="mb-1">Booking End Image</p>
                                                            <ImageViewer src={`${process.env.REACT_APP_IMAGE_ENDPOINT}${booking_data?.data?.end_image}`} image_style={{ height: "200px", width: "200px" }} image_classname="me-2" />
                                                        </div>
                                                    ) : null
                                                }
                                            </div>
                                        </div>
                                    ) : null
                                }
                                <div className="col-12 d-flex flex-column">
                                    {
                                        messages?.map(item => {
                                            return (
                                                <div className="p-3 my-3" style={{ alignSelf: item?.sender?._id === user?._id ? "end" : "start", minHeight: "100px", backgroundColor: "white", minWidth: "50vw", maxWidth: "60vw", borderRadius: "12px" }}>
                                                    <ProfileDisplay
                                                        name={item?.sender?._id === user?._id ? `${user?.first_name} ${user?.last_name}` : item?.sender?.full_name || `${item?.sender?.first_name} ${item?.sender?.last_name}`}
                                                        email={item?.sender?.email}
                                                        image={item?.sender?._id === user?._id ? user?.profile_photo : item?.sender?.profile_photo}
                                                    />
                                                    <p className="mt-2">{item?.message}</p>
                                                    <p className="m-0 text-end">{dateFormatter(item?.createdAt)}</p>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                                <div className="row">
                                    <div className="col-md-11">
                                        <CustomInput placeholder="Write Message Here ..." inputClass='mainInput' value={message} onChange={e => setMessage(e?.target?.value)} />
                                    </div>
                                    <div className="col-md-1">
                                        <CustomButton text="Send" variant='primaryButton mt-1' onClick={sendMessage} />
                                    </div>
                                </div>
                            </>
                    }
                </div>
            </div>
        </DashboardLayout >
    )
}

export default Messages